import ContinuePage from "@components/ContinuePage"

export default function LooksmaxxingUnleashLookPage() {
  return <ContinuePage emoji="🔬" translationKey="unleashLookLooksmaxxing" />
}
